import RefAutoComplete from 'antd/es/auto-complete';
import { Role } from 'core/models/user';
import { Admin } from 'modules/admins/models/Admin';
import { Permission } from 'modules/roles/models/roles';

class AuthService {
	private user: Admin | null = null;
	private permissions: string[] = [];
	private roles: Role[] = [];

	setToken(token: string, save: boolean) {
		sessionStorage.setItem('token', token);
		if (save) localStorage.setItem('token', token);
	}

	getToken(): string | null {
		return sessionStorage.getItem('token') || localStorage.getItem('token');
	}

	setUser(user: any) {
		this.user = user;
	}

	getUser() {
		return this.user;
	}

	setRoles(roles: Role[]) {
		this.roles = roles;
	}

	getRoles() {
		return this.roles;
	}

	setPermissions(permissions: string[]) {
		this.permissions = permissions;
	}

	getPermissions() {
		return this.permissions;
	}

	clearAuthData(): void {
		localStorage.removeItem('token');
		sessionStorage.removeItem('token');
		this.user = null;
		this.permissions = [];
		this.roles = [];
	}

	isAuthenticated(): boolean {
		return !!this.getToken();
	}

	isPermittedToAction(action: string) {
		return this.permissions.includes(action);
	}

	isPermittedToModule(module: string) {
		return this.permissions.some((action) => action.includes(module));
	}
}

// Export a singleton instance of AuthService
const authService = new AuthService();
export default authService;
